export enum PreAdmissionTab {
	progress = 0,
	submitted = 1,
	notSuitable = 2,
	all = 3,
}

export enum Sex {
	male = 0,
	female = 1,
}

export enum Language {
	chinese = 0,
	english = 1,
}

/** `AgeSourceEnum`: which value a member's age comes from (CHA-009). */
export enum AgeSource {
	dateOfBirth = 0,
	estimatedAge = 1,
}

export enum FormManagementStatus {
	draft = 0,
	submitted = 1,
	uploaded = 2,
}

export enum FormManagementType {
	faceSheet = 'face-sheet',
	enquiryRecord = 'enquiry-record',
	appendix4 = 'appendix4',
	appendix5 = 'appendix5',
	appendix6 = 'appendix6',
	appendix7 = 'appendix7',
	memberApplication = 'member-application',
	familyMember = 'family-member',
	newConsent = 'new-consent',
	stopService = 'stop-service',
	wellBeingScale = 'well-being-scale',
	recoveryAssessmentScale = 'recovery-assessment-scale',
	dsm5Adult = 'dsm5-adult',
	dsm5Teen = 'dsm5-teen',
	all = 'all',

	intakeSummary = 'intake-summary',
	personCenteredCarePlan = 'person-centered-care-plan',
	theModifiedScaleForSuicidalDeationMssi = 'the-Modified-scale-for-suicidal-deation-MSSI',
	twoMinutesRiskAssessmentOfViolenceApplicableForFamilyMemberOutreaching = 'two-minutes-risk-assessment-of-violence-applicable-for-family-member-outreaching',
	twoMinutesRiskAssessmentOfViolenceApplicableForOfficeInterview = 'two-minutes-risk-assessment-of-violence-applicable-for-office-interview',
	otherAssessmentFormsIfNeeded = 'other-assessment-forms-if-needed',
	caseTerminationTransferalReport = 'case-termination-transferal-report',
	caseNote = 'case-note',
	safetyPlanSuicide = 'safety-plan-suicide',
	safetyPlanViolence = 'safety-plan-violence',
	progressReportToCmoOrReferrer = 'progress-report-to-CMO-or-referrer',
	referralForCommunityPsychiatricServiceAppendix10 = 'referral-for-community-psychiatric-service-appendix10',
	referralForWelfareServiceAppendix8 = 'referral-for-welfare-service-appendix8',
	otherDocuments = 'other-documents',
	whoDisabilityAssessmentSchedule2_0 = 'WHO-disability-assessment-schedule2.0',
	incidentReportSuicide = 'incident-report-suicide',
	incidentReportViolence = 'incident-report-violence',
	interRaiCommunityMentalHealth9_2 = 'interRAI-community-mental-health9.2',
}

export enum FormManagementTypeEnum {
	'face-sheet' = 0,
	'enquiry-record' = 1,
	'appendix4' = 2,
	'appendix5' = 3,
	'appendix6' = 4,
	'member-application' = 5,
	'family-member' = 6,
	'new-consent' = 7,
	'stop-service' = 8,
	'appendix7' = 9,
	'intake-summary' = 10,
	'well-being-scale' = 11,
	'recovery-assessment-scale' = 12,
	'person-centered-care-plan' = 13,
	'dsm5-adult' = 14,
	'dsm5-teen' = 15,
	'the-Modified-scale-for-suicidal-deation-MSSI' = 16,
	'two-minutes-risk-assessment-of-violence-applicable-for-family-member-outreaching' = 17,
	'two-minutes-risk-assessment-of-violence-applicable-for-office-interview' = 18,
	'other-assessment-forms-if-needed' = 19,
	'case-termination-transferal-report' = 20,
	'case-note' = 21,
	'safety-plan-suicide' = 22,
	'safety-plan-violence' = 23,
	'progress-report-to-CMO-or-referrer' = 24,
	'referral-for-community-psychiatric-service-appendix10' = 25,
	'referral-for-welfare-service-appendix8' = 26,
	'other-documents' = 27,
	'WHO-disability-assessment-schedule2.0' = 28,
	'incident-report-suicide' = 29,
	'incident-report-violence' = 30,
	'interRAI-community-mental-health9.2' = 31,
	all = '',
}

export enum MemberStatusEnum {
	InProgressNoAdmitted = 0,
	InProgressAdmitted = 1,
	AwaitingAssignmentNoAdmitted = 2,
	AwaitingAssignmentAdmitted = 3,
	PendingIntakeNoAdmitted = 4,
	PendingIntakeAdmitted = 5,
	IntakeCompletedNoAdmitted = 6,
	IntakeCompletedAdmitted = 7,
	NotCounted = 8,
	All = 9,
}

export enum FamilyMemberStatusEnum {
	Admitted = 0,
	AllServicesClosed = 1,
}

export enum RiskLevelEnum {
	Low = 0,
	Medium = 1,
	High = 2,
}

export enum ServiceFollowEnum {
	Program = 0,
	Case = 1,
	ProgramCloseCase = 2,
	Noservice = 3,
	NoserviceCloseCase = 4,
	NoCounted = 5,
}

export enum CaseNoteStatusEnum {
	None = 0,
	Draft = 1,
	Submitted = 2,
}

export enum PermissionEnum {
	SummaryOfSystemUser = 0, // Summary of system user
	CreateSystemUserAccount = 1, // Create system user account
	EditSystemUserAccount = 2, // Edit system user account
	ViewSystemUserAccount = 3, // View system user account
	SuspendSystemUserAccount = 4, // Suspend system user account
	DeleteSystemUserAccount = 5, // Delete system user account
	SummaryOfPreAdmission = 6, // Summary of pre-admission
	CreatePreAdmission = 7, // Create pre-admission
	EditPreAdmissionWhenStatusInProgress = 8, // Edit pre-admission (when status = in-progress)
	EditPreAdmissionWhenStatusSubmittedOrNotSuitable = 9, // Edit pre-admission (when status = submitted or not suitable)
	ViewPreAdmission = 10, // View pre-admission
	DeletePreAdmission = 11, // Delete pre-admission
	ChangeStatusOfPreAdmission = 12, // Change status of pre-admission
	SummaryOfMember = 13, // Summary of member
	SummaryOfAdmissionRequest = 14, // Summary of admission request
	ViewAdmissionRequestAndMember = 15, // View admission request & member
	EditAdmissionRequestAndMember = 16, // Edit admission request & member
	DeleteAdmissionRequestAndMember = 17, // Delete admission request & member
	SummaryOfPendingSubmission = 18, // Summary of Pending Submission
	SummaryOfAwaitingAssignment = 19, // Summary of Awaiting Assignment
	SummaryOfPendingIntake = 20, // Summary of Pending Intake
	ChangeMembership_NewRegisterAsProgramMember = 21, // Change membership - New Register as a Program Member
	ChangeMembership_NewRegisterAsCaseMember = 22, // Change membership - New Register as a Case Member
	ChangeMembership_OpenCase = 23, // Change membership - Open Case
	ChangeMembership_CloseCase = 24, // Change membership - Close Case
	ChangeMembership_CloseAllMembershipWhenCaseNo = 25, // Change membership - Close All Membership [Remarks: When is a Case = No]
	ChangeMembership_CloseAllMembershipWhenCaseYes = 26, // Change membership - Close All Membership [Remarks: When is a Case = Yes]
	ChangeMembership_ReRegisterAsProgramMember = 27, // Change membership - Re-register as a Program Member
	ChangeMembership_ReRegisterAsCaseMember = 28, // Change membership - Re-register as a Case Member
	ActionButton_SubmitToIC = 29, // Action button - Submit to IC
	ActionButton_ReturnFromIC = 30, // Action button - Return from IC
	ActionButton_AssignCaseWorkers = 31, // Action button - Assign case workers
	ActionButton_AssignProgramWorkers = 32, // Action button - Assign program workers
	ActionButton_CloseNotSuitable = 33, // Action button - Close (Not suitable)
	ActionButton_UpdateSharedWithProfessionals = 34, // Action button - Update shared with professionals
	ActionButton_TransferCaseWorkers = 35, // Action button - Transfer case workers
	ActionButton_TransferProgramWorkers = 36, // Action button - Transfer program workers
	ActionButton_ClearAllCaseWorkers = 37, // Action button - Clear all case workers
	ActionButton_ClearAllProgramWorkers = 38, // Action button - Clear all program workers
	MemberChangeHistoryTab = 39, // Member - Change History - Tab
	MemberManageFamilyMemberTab = 40, // Member - manage family member - Tab
	MemberManageFamilyMemberAddMember = 41, // Member - manage family member - add member
	MemberManageFamilyMemberAddFamilyMember = 42, // Member - manage family member - add family member
	MemberInterventionSummaryTab = 43, // Member - Intervention Summary - Tab
	MemberIncidentMemberLookup = 44, // Member - Incident member lookup
	SummaryOfFamilyMember = 45, // Summary of family member
	CreateFamilyMember = 46, // Create family member
	EditFamilyMember = 47, // Edit family member
	ViewFamilyMember = 48, // View family member
	DeleteFamilyMember = 49, // Delete family member
	FamilyMemberManageFamilyMemberTab = 50, // Family Member - Manage Family Member - Tab
	FamilyMemberMembershipActionButtonCloseAllMembership = 51, // Family Member - Membership action button - Close All Membership
	FamilyMemberFormManagementTab = 52, // Family Member - Form Management - Tab
	SummaryOfForm = 53, // Summary of form
	CreateOnlineForm = 54, // Create online form
	UploadOnlineForm = 55, // Upload online form
	EditDraftForm = 56, // Edit draft form
	ViewSubmittedOrUploadedForm = 57, // View submitted/uploaded form
	DeleteDraftForm = 58, // Delete draft form
	DownloadForm = 59, // Download form
	DeleteSubmittedOrUploadedForm = 60, // Delete submitted/uploaded form
	CaseManagementMyCaseSummary = 61, // Case Management - My case summary
	CaseManagementCentreCaseSummary = 62, // Case Management - Centre case summary
	CaseManagementMyProgramMemberSummary = 63, // Case Management - My program member summary
	CaseManagementCentreProgramMemberSummary = 64, // Case Management - Centre program member summary
	CaseManagementMyInterventionSummary = 65, // Case Management - My intervention summary
	CaseManagementCentreInterventionSummary = 66, // Case Management - Centre intervention summary
	CaseManagementCreateIntervention = 67, // Case Management - Create intervention
	CaseManagementInterventionDetailsAllExcludingCaseNote = 68, // Case Management - Intervention Details - All excluding case note
	CaseManagementInterventionDetailsCaseNoteAssignedMember = 69, // Case Management - Intervention Details - Case note - Assigned Member
	CaseManagementInterventionDetailsCaseNoteNonAssignedMember = 70, // Case Management - Intervention Details - Case note - Non_assigned Member
	CaseManagementEditIntervention = 71, // Case Management - Edit intervention
	CaseManagementDeleteIntervention = 72, // Case Management - Delete intervention
	CaseManagementEditCaseNote = 73, // Case Management - Edit Case Note
	CaseManagementCaseNoteChangeStatusRevertToDraft = 74, // Case Management - Case Note Change Status - Revert to draft
	CaseManagementExportInterventionExcelAssignedMember = 75, // Case Management - Export Intervention Excel - Assigned Member
	CaseManagementExportInterventionExcelNonAssignedMember = 76, // Case Management - Export Intervention Excel - Non_assigned Member
	SummaryOfFieldOptionManagement = 77, // Summary of field option management
	OptionManagementCreate = 78, // Option Management - Create
	OptionManagementEdit = 79, // Option Management - Edit
	OptionManagementManageStatus = 80, // Option Management - Manage status
	OptionManagementReOrder = 81, // Option Management - Re-order
}

export enum MenuEnum {
	PreAdmissionManagement = 0,
	MemberManagement = 1,
	MemberSummary = 2,
	AdmissionRequestSummary = 3,
	PendingSubmissionSummary = 4,
	AwaitingAssignmentSummary = 5,
	PendingIntakeSummary = 6,
	CaseManagement = 7,
	MyCaseSummary = 8,
	CentreCaseSummary = 9,
	MyProgramMemberSummary = 10,
	CentreProgramMemberSummary = 11,
	MyInterventionSummary = 12,
	CentreInterventionSummary = 13,
	SystemUserManagement = 14,
	FamilyMemberSummary = 15,
	FieldOptionsSummary = 16,
}

export enum TypeOfQueryServiceFollowListEnum {
	All = 0,
	Case = 1,
	Program = 2,
	NoService = 3,
}

export enum PIRTypeEnum {
	MemberOfThisCentre = 0,
	NonMemberOfThisCentre = 1,
	NoInformation = 2,
}

export enum TypeOfQueryMemberStatusListEnum {
	IN_PROGRESS = 0,
	AWAITING_ASSIGNMENT = 1,
	PENDING_INTAKE = 2,
	NOT_ADMITTED = 3,
	ADMITTED = 4,
	ALL_SERVICES_CLOSED = 5,
	ADMISSION_REQUEST_SUMMARY = 6,
	ALL_MEMBER_SUMMARY = 7,
	CASE_MEMBER_SUMMARY = 8,
	PROGRAM_MEMBER_SUMMARY = 9,
	CLOSE_SERVICE_MEMBER_SUMMARY = 10,
}
